export const AI_ADVISOR_BRAND_NAME = 'AI Advisor';
